import { useState, useEffect } from 'react'
import Modal, { FormField, FormInput, FormTextarea, FormActions, Button } from '../shared/Modal'
import { getAPIBaseUrl } from '../../environment'

const API_BASE = getAPIBaseUrl()

function EditRunModal({ isOpen, onClose, run, accountId, onSaved }) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (isOpen && run) {
      setName(run.display_name || run.workflow_name || '')
      setDescription(run.description || '')
      setError(null)
    }
  }, [isOpen, run])

  const handleSave = async () => {
    if (!name.trim()) return
    setSaving(true)
    setError(null)
    try {
      const token = localStorage.getItem('modernizeit_token')
      const res = await fetch(`${API_BASE}/workflows/runs/${run.workflow_run_id}/details`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          account_id: accountId,
          display_name: name.trim(),
          description: description.trim(),
        }),
      })
      if (!res.ok) throw new Error('Save failed')
      onSaved({ ...run, display_name: name.trim(), workflow_name: name.trim(), description: description.trim() })
      onClose()
    } catch (e) {
      setError('Failed to save — please try again')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Run" size="medium">
      <FormField label="Run Name" required>
        <FormInput
          value={name}
          onChange={setName}
          placeholder="Run name..."
          autoFocus
        />
      </FormField>

      <FormField label="Description">
        <FormTextarea
          value={description}
          onChange={setDescription}
          placeholder="Optional notes about this run..."
          rows={3}
        />
      </FormField>

      {error && (
        <p style={{ color: 'var(--accent-red)', fontSize: '13px', margin: '0 0 12px' }}>{error}</p>
      )}

      <FormActions>
        <Button variant="secondary" onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="primary" onClick={handleSave} disabled={saving || !name.trim()}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </FormActions>
    </Modal>
  )
}

export default EditRunModal
